import type { RightRail } from 'utils/hooks/rightRailRegistry'

export const CHAT_WIDGET_RIGHT_VAR = '--chat-widget-right'

export const CHAT_WIDGET_BOTTOM_VAR = '--chat-widget-bottom'

const FLOATING_EDGE_OFFSET = '2.4rem'

const RIGHT_RAIL_MARGIN = '0.8rem'

const LAUNCHER_SIZE_PX = 48

const RIGHT_RAIL_MARGIN_PX = 8

export const fitsBesideRightRail = (rail: RightRail) =>
  rail.width > 0 && rail.gap >= LAUNCHER_SIZE_PX + 2 * RIGHT_RAIL_MARGIN_PX

interface PlacementInput {
  rail: RightRail
  bottomActionBarClearance: number
  railFooterClearance: number
}

const atEdge = (clearance: number) => ({
  right: FLOATING_EDGE_OFFSET,
  bottom: `calc(${FLOATING_EDGE_OFFSET} + ${clearance}px)`,
})

export const resolveLauncherPlacement = ({ rail, bottomActionBarClearance, railFooterClearance }: PlacementInput) => {
  if (bottomActionBarClearance > 0) return atEdge(bottomActionBarClearance)

  if (fitsBesideRightRail(rail)) {
    return {
      right: `calc(${rail.width}px + ${RIGHT_RAIL_MARGIN})`,
      bottom: FLOATING_EDGE_OFFSET,
    }
  }

  return atEdge(railFooterClearance)
}
